import React, { useEffect } from 'react';
import { Form, Input, Button, Upload } from 'antd';
import { UploadOutlined } from "@ant-design/icons";

const CSRForm = ({ initialValues = {}, onSubmit }) => {
  const [form] = Form.useForm();

useEffect(() => {
  if (initialValues) {
    const newInitialValues = { ...initialValues };

    if (initialValues.image && typeof initialValues.image === 'string') {
      console.log("newInitialValues.image", newInitialValues.image);
      newInitialValues.image = [
        {
          uid: '-1',
          name: 'image.jpg',
          status: 'done',
          url: process.env.REACT_APP_API_BASE_URL+`${initialValues.image}`,
        },
      ];
    }

    form.setFieldsValue(newInitialValues);
  }
}, [initialValues, form]);

const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  const handleFinish = (values) => {
    const formData = new FormData();
    formData.append('year', values.year);
    formData.append('title_id', values.title_id);
    formData.append('title_en', values.title_en);
    formData.append('description_id', values.description_id);
    formData.append('description_en', values.description_en);

    if (values.image && values.image[0]) {
      formData.append("image", values.image[0].originFileObj); // ✅ FIXED typo
    }

    onSubmit(formData);
    form.resetFields();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
    >
      <Form.Item
        label="Year"
        name="year"
        rules={[{ required: true, message: 'Year harus diisi' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Title ID"
        name="title_id"
        rules={[{ required: true, message: 'Judul harus diisi' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Title EN"
        name="title_en"
        rules={[{ required: true, message: 'Judul harus diisi' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Description ID"
        name="description_id"
        rules={[{ required: true, message: 'Deskripsi harus diisi' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Description EN"
        name="description_en"
        rules={[{ required: true, message: 'Deskripsi harus diisi' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="image"
        label="Image"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={[{ required: true, message: "'image' is required" }]}
      >
        <Upload beforeUpload={() => false} listType="picture" maxCount={1}>
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
      </Form.Item>

      <Form.Item style={{ textAlign: 'right' }}>
          <Button
            htmlType="submit"
            style={{
              backgroundColor: '#ec4899',
              borderColor: '#ec4899',
              color: '#fff',
            }}          >
            Simpan
          </Button>
      </Form.Item>
    </Form>
  );
};

export default CSRForm;
